<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="8"
          ><div class="search-area-div">销售区域：</div>
          <el-select v-model="page.salesTerritoryGuid" filterable placeholder="请选择" class="ipt-sty" clearable>
            <el-option 
              v-for="item in salesData"
              :key="item.guid"
              :label="item.territoryName"
              :value="item.guid">
            </el-option>
          </el-select> 
          </el-col>
          <el-col :span="8"
          ><div class="search-area-div">年度：</div>
          <el-date-picker
            v-model="page.year"
            class="ipt-sty"
            type="year"
            value-format="yyyy"
            placeholder="选择年">
          </el-date-picker>
          </el-col>
          <el-col :span="8"
          ><div class="search-area-div">月份：</div>
          <el-date-picker
            v-model="page.month"
            type="month"
            class="ipt-sty"
            value-format="yyyy-MM"
            format="yyyy-MM"
            placeholder="选择月">
          </el-date-picker>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="mt15 t-right">
          <el-col :span="24">
            <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
            <el-button size="medium" type="danger" @click="empty">清空</el-button>
          </el-col>
        </el-row>
    </div>
    <!-- <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="add(1, '')">批量添加指标</el-button>
      <el-button size="medium" type="danger" @click="getDeleteData(1, '')">批量删除</el-button> 
      <el-button plain size="medium">历史数据</el-button>
    </div> -->
    <div class=" back-color-fff" style="padding: 16px;">
    <div class="summary-sty mt15">销售区域:<b class="fontC-4fa1a4"> {{salesCount}} </b>指标(元):<b class="fontC-4fa1a4"> {{salesTotal | numFmt | numDigit}}</b></div>
      <el-table :data="tableData" border style="width: 100%;" v-loading="loading">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="salesTerritoryName" label="销售区域" header-align="center" align="center"></el-table-column>
        <el-table-column prop="year" label="年度" header-align="center" align="center"></el-table-column> 
        <el-table-column prop="month" label="月份" sortable header-align="center" align="center"></el-table-column>
        <el-table-column prop="startDate" label="起始日期" sortable header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.startDate | getDate }}</template>
        </el-table-column>
        <el-table-column prop="endDate" label="截止日期" sortable header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.endDate | getDate }}</template>
        </el-table-column>
        <el-table-column prop="salesIndicators" label="指标(元)" sortable header-align="center" align="right">
          <template slot-scope="scope">{{ scope.row.salesIndicators | numFmt | numDigit }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="add(2, scope.row)">编辑 | </a>
            <a class="txt-color-red" @click="getDeleteData(scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog :title="textTitle" :visible.sync="dialogFormVisible" width="550px">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        :label-position="right"
        class="demo-ruleForm"
      >
        <el-form-item label="年度:" prop="year">
          <el-date-picker
            v-model="ruleForm.year"
            class="w100f"
            type="year"
            value-format="yyyy"
            placeholder="选择年">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="月份:" prop="month">
          <el-date-picker
            v-model="ruleForm.month"
            class="w100f"
            type="month"
            value-format="yyyy-MM"
            @change="changeMonth"
            placeholder="选择年">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="起始-截止日期:" prop="timeList">
          <el-date-picker
            v-model="ruleForm.timeList"
            type="daterange"
            class="w100f"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <div style="border-top: 1px solid #cccccc;height: 40px;line-height: 40px;text-align: right;">合计已填写销售区：{{salesDataSum}}个；指标金额(元)：{{salesIndicatorsSum | numFmt | numDigit}}</div>
        <div v-for="sa in salesData">
              <!-- <div>{{sa.territoryName}} <el-input v-model="sa.salesIndicators"></el-input></div> -->
              <el-form-item :label="sa.territoryName"> 
               <el-input-number v-model="sa.salesIndicators" @change="handleChange" :min="0" :precision="2" class="w100f"></el-input-number>
            </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="medium" type="info" @click="submitForm('ruleForm')"
          >确定</el-button
        > 
      </div>
    </el-dialog>
    <el-dialog :title="textTitle" :visible.sync="dialogFormVisible1" width="550px">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        :label-position="right"
        class="demo-ruleForm"
      >
        <el-form-item label="年度:" prop="year">
          <el-date-picker
            v-model="ruleForm.year"
            class="w100f"
            type="year"
            value-format="yyyy"
            placeholder="选择年">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="起始-截止日期:" prop="timeList">
          <el-date-picker
            v-model="ruleForm.timeList"
            type="daterange"
            class="w100f"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <div style="border-top: 1px solid #cccccc;height: 40px;line-height: 40px;text-align: right;">合计已填写省区：{{salesDataSum}}个；指标金额(元)：{{salesIndicatorsSum | numFmt | numDigit}}</div>
        <div v-for="sa in salesData1">
              <!-- <div>{{sa.territoryName}} <el-input v-model="sa.salesIndicators"></el-input></div> -->
              <el-form-item :label="sa.territoryName"> 
               <el-input-number v-model="sa.salesIndicators" @change="handleChange1" class="w100f" :min="0" :precision="2"></el-input-number>
            </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogFormVisible1 = false">取消</el-button>
        <el-button size="medium" type="info" @click="upDateForm('ruleForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input: '',
      textTitle: '',
      right: '',
      dialogVisible: false,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      formLabelWidth: '120px',
      ruleForm: {
        year: '',
        month:'',
        timeList:[]
      },
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid:'',
        organisationGuid:this.$router.history.current.query.guid,
        salesTerritoryGuid: this.$router.history.current.query.salesTerritoryGuid,
        year: '',
        month:'',
        startDate: '', 
        endDate: '', 
      },
      loading:false,
      tableData: [],
      salesData: [],
      salesData1:[],
      salesListData:[],
      rules: {
        year: [
          { required: true, message: '请选择年份', trigger: 'blur' },
          { min: 1, max: 60, message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
        month: [
          { required: true, message: '请选择月份', trigger: 'blur' },
          { min: 1, max: 60, message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
        timeList: [
          { type: 'array', required: true, message: '请选择日期', trigger: 'change' }, 
        ], 
      },
      multipleSelection: [],
      salesIndicators:[],
      salesIndicatorsSum:0,
      salesDataSum:0,
      salesTerritoryGuid:'',
      salesTotal:0,
      salesCount:0,
      startDate:'',
      endDate:''
    };
  },
  created() {
    // 列表
    this.getSalesTerritory();
    // this.getSalesTerritoryData();
    let date = new Date();
    let year = date.getFullYear().toString();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    this.page.year = year;
    this.ruleForm.year = year;
    if(month < 10){
      month = '0'+ month
    }
    this.page.month = date.getFullYear()+'-'+month;
    this.ruleForm.month = date.getFullYear()+'-'+month;
    // this.startDate = year +'-'+month+'-01';
    // this.endDate = year +'-'+month+'-'+day;
    // this.ruleForm.timeList = [startData,endData];
    this.getData(false);
  },
  watch:{
    salesListData: {
      handler(newValue, oldValue) {
        console.log(newValue);
        this.salesListData = newValue;
      },
      deep: true,
    },
  },
  methods: {
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid:'',
        salesTerritoryGuid: '',
        year: '',
        month:'',
        startDate: '', 
        endDate: '', 
      };
      self.getData(true);
    },
    handleChange(value) {
      let self = this;
      self.salesIndicatorsSum = 0;
      self.salesDataSum = 0;
      if(self.salesListData !==null){
        self.salesListData.forEach(function(item){
          if(item.salesIndicators){
              self.salesDataSum++;
              self.salesIndicatorsSum += item.salesIndicators
          } 
        })
      }
      console.log(self.salesIndicatorsSum);
    },
    handleChange1(value) {
      let self = this;
      self.salesIndicatorsSum = 0;
      self.salesDataSum = 0;
      if(self.salesData1 !== null){
        self.salesData1.forEach(function(item){
          if(item.salesIndicators){
              self.salesDataSum++;
              self.salesIndicatorsSum += item.salesIndicators
          } 
        })
      }
      console.log(self.salesIndicatorsSum);
    },
    changeMonth(){
       this.getSalesTerritoryData();
    },
    //获取组织的销售区域
    getSalesTerritory() {
      let self = this;
      let tenantGuid = self.$store.getters.getTenantGuid; 
      // self.page.salesTerritoryGuid = '';
      let promise = {
        tenantGuid: tenantGuid,
        organisationGuid: self.$router.history.current.query.guid,
        pageIndex: self.page.pageIndex,
        pageSize: '-1',
      };  
      self.api.postJson(`/${serverConfig.msSalesPerformService}/sales-territory/data/get-sales-territory`,promise)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if(res.data.data.records != null){
              self.salesData = res.data.data.records;
              self.salesData.forEach((item)=>{
                item.salesIndicators = 0;
              })
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getData(flg) {
      let self = this;
      self.loading = true;
      if (flg) {
        self.page.pageIndex = 1;
      }
      // self.page.tenantGuid = self.$store.getters.getTenantGuid; 
      let promise = {
        pageIndex: self.page.pageIndex,
        pageSize: self.page.pageSize,
        totalPage: self.page.totalPage,
        totalRows: self.page.totalRows,
        tenantGuid:self.$store.getters.getTenantGuid,
        salesTerritoryGuid: self.page.salesTerritoryGuid,
        year: self.page.year,
        organisationGuid:self.$router.history.current.query.guid,
        month:self.page.month.replace(/-/g,''),
        startDate: self.page.startDate, 
        endDate: self.page.endDate, 
      }
      // self.page.month = self.page.month.replace(/-/g,'')
      self.api.postJson(`/${serverConfig.msSalesPerformService}/sales-territory/data/get-page-sales-territory-indicator`, promise).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.loading = false; 
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
          self.getSalesTerritoryIndicatorTotal();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function(item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
      });
    },
    getSalesTerritoryData() {
      let self = this; 
      console.log('11',self.salesData);
      // self.page.tenantGuid = self.$store.getters.getTenantGuid; 
      let promise = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid:self.$store.getters.getTenantGuid,
        salesTerritoryGuid: '',
        year: self.ruleForm.year,
        month:self.ruleForm.month.replace(/-/g,''),
        organisationGuid:self.$router.history.current.query.guid,
        // startDate: self.page.startDate, 
        // endDate: self.page.endDate, 
      }
      // self.page.month = self.page.month.replace(/-/g,'')
      self.api.postJson(`/${serverConfig.msSalesPerformService}/sales-territory/data/get-page-sales-territory-indicator`, promise).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.salesListData = res.data.data.records; 
          if(self.salesData !== null){
            self.salesData.forEach((item)=>{ 
              if(self.salesListData !== null){
                self.salesListData.forEach((items)=>{
                  if(item.territoryName == items.salesTerritoryName){
                    item.salesIndicators = items.salesIndicators;
                  }  
                })
              }else{
                item.salesIndicators = 0;
              }
            })   
          }
          if(self.salesListData !==null){
            self.salesListData.forEach(function(item){
              if(item.salesIndicators){
                  self.salesDataSum++;
                  self.salesIndicatorsSum += item.salesIndicators
              } 
            })
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getDeleteData(guid) {
      let self = this;
      self.api
      .postJson(`/${serverConfig.msSalesPerformService}/sales-territory/data/delete-sales-territory-indicator?guid=${guid}`)
      .then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('删除成功!');
          self.getData(true);
          self.getSalesTerritoryData();
          // self.getSalesTerritoryIndicatorTotal();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    add(flg, row) {
      let self = this; 
      // self.ruleForm.year = self.page.year;
      // self.ruleForm.month = self.page.month;
      if (flg == 1) { 
        self.textTitle = '添加指标'; 
        self.ruleForm.timeList = [self.startDate,self.endDate]; 
        self.salesIndicatorsSum = 0;
        self.salesDataSum = 0;
        self.getSalesTerritoryData();
        // if((((self.ruleForm.year!==null) && (self.ruleForm.year!==null))&&((self.ruleForm.month!=='') && (self.ruleForm.month!=='')))){
          
        // }else{
        //   self.salesData.forEach((item)=>{ 
        //     item.salesIndicators = 0;
        //   })   
        
        //   self.$message.error('年度月份不能为空！');

        // }
        self.dialogFormVisible = true;
      } else {
        self.textTitle = '编辑指标';
        self.salesIndicatorsSum = 0;
        self.salesDataSum = 0;
        self.salesData1 = [];
        self.ruleForm.year = row.year;
        self.salesTerritoryGuid = row.salesTerritoryGuid;
        self.ruleForm.timeList = [row.startDate,row.endDate];
        let item = {
              territoryName:row.salesTerritoryName,
              salesIndicators:row.salesIndicators,
        }
        self.salesData1.push(item);
        if(self.salesData1 !== null){
          self.salesData1.forEach(function(item){
            if(item.salesIndicators){
                self.salesDataSum++;
                self.salesIndicatorsSum += item.salesIndicators
            } 
          })
        }
        this.dialogFormVisible1 = true;
      }
      
    },
    submitForm(formName) {
      let self = this;
      self.salesIndicators = [];
      self.$refs[formName].validate(valid => {
        if (valid) {
          if ( self.ruleForm.timeList && Array.isArray(self.ruleForm.timeList) && self.ruleForm.timeList.length > 0 && self.ruleForm.timeList[0] && self.ruleForm.timeList[1] ) {
            self.page.startDate = self.$moment(self.ruleForm.timeList[0]).format('YYYY-MM-DD');
            self.page.endDate = self.$moment(self.ruleForm.timeList[1]).format('YYYY-MM-DD');
          } else {
            self.page.startDate = '';
            self.page.endDate = '';
          }
          self.salesData.forEach(function(i){
            let item = {
              tenantGuid: self.$store.getters.getTenantGuid,
              year: self.ruleForm.year,
              month:self.ruleForm.month.replace(/-/g,''),
              startDate: self.page.startDate,
              endDate: self.page.endDate,
              salesTerritoryGuid: i.guid,
              salesIndicators: i.salesIndicators,
            }
            if(i.salesIndicators !== 0){
              self.salesIndicators.push(item);
            }
          })  
          self.api.postJson(`/${serverConfig.msSalesPerformService}/sales-territory/data/add-sales-territory-indicator`, self.salesIndicators).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.dialogFormVisible = false;
              self.$message.success('添加指标成功');
              self.page.startDate = '';
              self.page.endDate = '';
              self.getData(true); 
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    upDateForm(formName) {
      let self = this;
      self.salesIndicators = [];
      self.$refs[formName].validate(valid => {
        if (valid) {
          if ( self.ruleForm.timeList && Array.isArray(self.ruleForm.timeList) && self.ruleForm.timeList.length > 0 && self.ruleForm.timeList[0] && self.ruleForm.timeList[1] ) {
            self.page.startDate = self.$moment(self.ruleForm.timeList[0]).format('YYYY-MM-DD');
            self.page.endDate = self.$moment(self.ruleForm.timeList[1]).format('YYYY-MM-DD');
          } else {
            self.page.startDate = '';
            self.page.endDate = '';
          }
          self.salesData1.forEach(function(i){
            let item = {
              tenantGuid: self.$store.getters.getTenantGuid,
              year: self.ruleForm.year,
              startDate: self.page.startDate,
              endDate: self.page.endDate,
              salesTerritoryGuid: self.salesTerritoryGuid,
              salesIndicators: i.salesIndicators,
            }
            self.salesIndicators.push(item);
            })  
          self.api.postJson(`/${serverConfig.msSalesPerformService}/sales-territory/data/add-sales-territory-indicator`, self.salesIndicators).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.dialogFormVisible1 = false;
              self.$message.success('编辑指标成功');
              self.page.startDate = '';
              self.page.endDate = '';
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //获取组织的销售区域
    getSalesTerritoryIndicatorTotal() {
      let self = this; 
      let promise = {
        pageIndex: self.page.pageIndex,
        pageSize: self.page.pageSize,
        totalPage: self.page.totalPage,
        totalRows: self.page.totalRows,
        tenantGuid:self.$store.getters.getTenantGuid,
        salesTerritoryGuid: self.page.salesTerritoryGuid,
        organisationGuid:self.$router.history.current.query.guid,
        year: self.page.year,
        month:self.page.month.replace(/-/g,''),
        startDate: self.page.startDate, 
        endDate: self.page.endDate, 
      }
      self.api.postJson(`/${serverConfig.msSalesPerformService}/sales-territory/data/get-sales-territory-indicator-total`,promise)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) { 
                  self.salesCount = res.data.data.count;  
                  self.salesTotal = res.data.data.total;  
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script>
